import React, { Component } from 'react'
import YouTube from 'react-youtube';

class BackgroundYoutube extends Component {
    constructor(props) {
        super(props)
    }

    componentWillUnmount() {
        this.props.onPlayerUmount()
    }

    render() {
        const { youtubeId, trailerTime, width = "640", height ="360", iframeClass= "", onPlayerReady, onPlayerStateChange, onPlayerEnd } = this.props

        return <YouTube
            className={iframeClass}
            videoId={youtubeId}
            onReady={onPlayerReady}
            onStateChange={onPlayerStateChange}
            onEnd={onPlayerEnd}
            onPause={onPlayerEnd}
            opts={{
                width: width,
                height: height,
                frameborder: "0",
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    rel: 0,
                    showinfo: 0,
                    mute: 1,
                    loop: 1,
                    disablekb: 1,
                    modestbranding: 1,
                    start: trailerTime
                    // origin: 'https://www.youtube.com'
                },
            }}
        />
    }
}

export default BackgroundYoutube